import { z } from "zod/v4";

export const boostTierSchema = z.object({
	duration_days: z.number(),
	price_cents: z.number(),
	currency: z.string(),
	label: z.string(),
});

export const boostPricingSchema = z.object({
	tiers: z.array(boostTierSchema),
});

export const boostStatusSchema = z.object({
	active: z.boolean(),
	expires_at: z.string().nullable().optional(),
	boost: z
		.object({
			id: z.string(),
			club_id: z.string(),
			duration_days: z.number(),
			price_cents: z.number(),
			status: z.string(),
			starts_at: z.string().nullable().optional(),
			expires_at: z.string().nullable().optional(),
		})
		.nullable()
		.optional(),
});

export const boostCheckoutResponseSchema = z.object({
	checkout_url: z.string(),
	boost_id: z.string(),
});

export type BoostTier = z.infer<typeof boostTierSchema>;
export type BoostPricing = z.infer<typeof boostPricingSchema>;
export type BoostStatus = z.infer<typeof boostStatusSchema>;
export type BoostCheckoutResponse = z.infer<typeof boostCheckoutResponseSchema>;
